function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.7612 10.7724L12.4008 1.41066C11.8488 0.859975 10.9558 0.866491 10.4109 1.40996C9.86302 1.95929 9.86302 2.85123 10.4109 3.39986L19.7727 12.761C20.3211 13.3094 21.2127 13.3094 21.7612 12.761C22.3112 12.211 22.3112 11.3223 21.7612 10.7724Z",
  fill: "#072E4B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.84943 3.88672L9.77898 4.23988C9.28271 6.72229 8.07661 9.08062 6.44531 10.992L11.5382 16.0849C13.4493 14.4539 15.7752 13.2154 18.2577 12.7185L18.6115 12.6481L9.84943 3.88672Z",
  fill: "#072E4B"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 11L2.02826 15.5268C1.20583 16.3492 1.20241 17.6844 2.02826 18.5102L4.01679 20.4988C4.83922 21.3212 6.17441 21.3246 7.00025 20.4988L11.5 16L6.5 11ZM6.00603 17.516C5.73139 17.7907 5.2864 17.7907 5.01176 17.516C4.73712 17.2414 4.73712 16.7964 5.01176 16.5218L6.00603 15.5275C6.28067 15.2528 6.72566 15.2528 7.0003 15.5275C7.27494 15.8021 7.27494 16.2471 7.0003 16.5218L6.00603 17.516Z",
  fill: "#072E4B"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.4275 19.6502L12.384 18.6937C13.2099 17.8679 13.2072 16.5327 12.384 15.711L11.6736 15C11.2809 15.2638 10.9059 15.5504 10.5413 15.8562L11.3898 16.7059C11.6637 16.9785 11.6657 17.4221 11.3898 17.6994L10.4175 18.6717L8.98863 17.2874L7 19.276L10.1902 22.3673C10.7346 22.9131 11.6284 22.9162 12.178 22.3666C12.7266 21.8179 12.7266 20.926 12.178 20.3773L11.4275 19.6502Z",
  fill: "#072E4B"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7031 1C15.3145 1 15 1.31448 15 1.70313V3.10938C15 3.49802 15.3145 3.81251 15.7031 3.81251C16.0918 3.81251 16.4063 3.49802 16.4063 3.10938V1.70313C16.4063 1.31448 16.0918 1 15.7031 1Z",
  fill: "#072E4B"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M21.3281 6.625H19.9219C19.5332 6.625 19.2188 6.93948 19.2188 7.32813C19.2188 7.71677 19.5332 8.03125 19.9219 8.03125H21.3281C21.7168 8.03125 22.0313 7.71677 22.0313 7.32813C22.0313 6.93948 21.7168 6.625 21.3281 6.625Z",
  fill: "#072E4B"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20.4151 2.61223C20.1404 2.33759 19.6955 2.33759 19.4208 2.61223L18.0146 4.01848C17.7399 4.29312 17.7399 4.73811 18.0146 5.01275C18.2892 5.28739 18.7342 5.28744 19.0088 5.01275L20.4151 3.6065C20.6897 3.33186 20.6897 2.88687 20.4151 2.61223Z",
  fill: "#072E4B"
});

var SvgBroadcastPageIcon = function SvgBroadcastPageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBroadcastPageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/broadcast-page-icon.06f686e2.svg";
export { ForwardRef as ReactComponent };